import script from "./InfoGather.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoGather.vue?vue&type=script&setup=true&lang=js"

import "./InfoGather.vue?vue&type=style&index=0&id=6502c3df&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6502c3df"]])

export default __exports__